import gql from 'graphql-tag';

export const ListSolutionHistorysQuery = gql`
  query ListSolutionHistorysQuery {
    solutionhistorys {
      solutionName
      startedOn
      completedOn
    }
  }
`;
